
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Http, Headers} from '@angular/http';
import { KYCRegister } from '../Class/CSARegister';
import { KYCAddress } from '../Class/kycaddress';
import { KYC } from '../Class/kyc';
import { KYCDocument } from '../Class/kycdocument';
import { KYCUserDetail } from '../Class/kycuserdetail';
import { DropDown } from '../Class/dropdown';
import{environment} from '../../environments/environment'
import { Observable } from 'rxjs/internal/Observable';
import { jsonpFactory } from '@angular/http/src/http_module';


@Injectable()
export class Registartionservice {

    
    dropdown: DropDown[];
    
    
    constructor(private _http: HttpClient) {
        
    }
    createAuthHeader(headers: Headers) {
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Basic ' + btoa('user-name:password')); 
      }
    SaveKycRegister(register: KYCRegister) {
        
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        //let headers = new HttpHeaders().set('Content-Type', 'application/json');
       
         headers.append('Access-Control-Allow-Origin', '*');
       //const config = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    //    const headers = new HttpHeaders()
    //  .set('Content-Type', 'application/x-www-form-urlencoded')
    //  //.set('Accept', 'application/json')
    //  .append('Access-Control-Allow-Origin', '*')
        return this._http.post(environment.apiEndpoint+'/CSNDetailCreation/AddKYCRegister/',  register, { headers: headers})
    }

    deleteAttachment(id, flag){
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/deleteAttachment/'+id +'/'+ flag) 
    }
    

    SaveKycDocument(document: KYCDocument[]) {    
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
         headers.append('Access-Control-Allow-Origin', '*');         
        return this._http.post(environment.apiEndpoint+'/CSNDetailCreation/AddKYCDocument/', document, { headers: headers});
    }

    SaveKycAdress(address: KYCAddress[]) {
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        headers.append('Access-Control-Allow-Origin', '*');  
        return this._http.post(environment.apiEndpoint+'/CSNDetailCreation/AddKYCAddress/', address, { headers: headers});
    }

    SaveKyc(kyc: KYC[]) {
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        headers.append('Access-Control-Allow-Origin', '*');
        return this._http.post(environment.apiEndpoint+'/CSNDetailCreation/AddKYC/', kyc, { headers: headers});
    }

    SaveKycUserDetail(userdetail: KYCUserDetail[]) {
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        headers.append('Access-Control-Allow-Origin', '*');
        return this._http.post(environment.apiEndpoint+'/CSNDetailCreation/AddKYCUserDetail/', userdetail, { headers: headers});
    }

    MakePayment(companyId: number) {
        return this._http.get("http://payment.mmd3.in/package-list/" + companyId);
    }
    Mail(PanNo: string) {
        return this._http.get("CSNDetailCreation/Mail" + PanNo);
    }

    UploadImageNew(CompnayName: string, fileToUpload: File){
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
       return this._http.post(environment.apiEndpoint+'/CSNDetailCreation/UploadImageNew/'+ CompnayName, formData);
   }
   uploadBCBAFile(userId : string){
    
       return this._http.get(environment.apiEndpoint+'/CSNDetailCreation/UploadImage/'+ userId);
   }

   BCBAImageUpload()
   {
    return this._http.get(environment.apiEndpoint+'/CSNDetailCreation/BCBAImageUpload/');
   }

   uploadFile1(fileToUpload: string){
        let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
       return this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetFile?fileName='+ fileToUpload,{responseType: 'arraybuffer',headers:headers});
   }
  
    GetPortList() {        
        
        var path=environment.apiEndpoint+'/CSNDetailCreation/GetPortOfLoading';             
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetPortOfLoading')
                                  
    }

    GetCityList() {        
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetCity')
                                  
    }

    GetPaymentHistory(panNo:string) {              
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetPaymentHistory/'+panNo)                                          
    }

    GetCompanyDetail(panNo:string) {              
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetCompanyDetail/'+panNo)                                          
    }

    GetCompanyAddress(Id:string) {              
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetCompanyAddress/'+Id)                                          
    }

    GetKYC(Id:string) {              
      return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetKYC/'+Id)                                          
    }

    GetUserDetail(Id:string) {    
         return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetUserDetail/'+Id)                                          
    }

    GetAttachmentDetail(Id:string) {              
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetAttachmentDetail/'+Id)                                          
    }


    GetStateList(cityid:number) {        
       
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetState/'+cityid)
                                  
    }

    GetCountryList() {        
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetCountry')
                                  
    }
    GetCompanyType() {    
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetCompanyType')
    }     

    GetUserDetails(guid:string) {              
        return  this._http.get(environment.apiEndpoint+'/CSNDetailCreation/GetUserDetails/'+guid)                                          
    }      
    
    GetLoginDetails(guid:string) {  
              let test = {
                'Cache-Control':  'no-cache, no-store, must-revalidate, post-  check=0, pre-check=0',
                'Pragma': 'no-cache',
                'Expires': '0'
              };

        return  this._http.get('https://bcba.ngauge.co.in/BCBAService.svc/getLoginDetails?UserID='+ guid)                                          
    }    
}

